import React from "react";
import CustomInput from "../../../../../components/CustomInput";
import CustomSelect from "../../../../../components/CustomSelect";

const ADJUSTMENT_TYPE_OPTIONS = [
  { value: "Tăng", label: "Tăng" },
  { value: "Giảm", label: "Giảm" },
  { value: "Cập nhật", label: "Cập nhật" },
];

const NEW_ADJUSTMENT_TYPE_OPTIONS = [
  { value: "Tăng", label: "Tăng" },
  { value: "Giảm", label: "Giảm" },
];

const RemoveButton = ({ onClick, title }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex w-12 shrink-0 items-center justify-center rounded-r-2xl bg-[#FD5C5C] text-white transition-colors hover:bg-red-500"
    title={title}
    aria-label={title}
  >
    <svg className="size-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
);

export const ReadonlyAdjustmentCard = ({ item, onRemove }) => (
  <div className="bg-[#F9FAFB] rounded-[16px] opacity-90 w-full mb-3">
    <div className="flex items-stretch">
      <div className="grid flex-1 grid-cols-3 gap-4 px-4 py-4 text-sm">
        <div>
          <label className="block text-xs text-gray-600 mb-2">Nội dung điều chỉnh</label>
          <CustomInput value={item?.reason} disabled height="43px" />
        </div>
        <div>
          <label className="block text-xs text-gray-600 mb-2">Loại điều chỉnh</label>
          <CustomSelect
            value={ADJUSTMENT_TYPE_OPTIONS.find((opt) => opt.value === item.type)}
            options={ADJUSTMENT_TYPE_OPTIONS}
            disabled
            height="43px"
          />
        </div>
        <div>
          <label className="block text-xs text-gray-600 mb-2">Số tiền</label>
          <CustomInput
            value={Number(item?.amount || 0).toLocaleString()}
            disabled
            height="43px"
          />
        </div>
      </div>
      <RemoveButton
        onClick={onRemove}
        title="Xoá lịch sử điều chỉnh giá"
      />
    </div>
  </div>
);

export const PendingApprovalAdjustmentCard = ({
  adjustment,
  onUpdate,
  onRemove,
}) => (
  <div className="bg-[linear-gradient(135deg,_rgba(241,246,254,0.9)_0%,_rgba(234,244,255,0.75)_100%)] rounded-[16px] w-full mb-2 border border-[#CFE0FF] shadow-[0_8px_24px_rgba(46,96,243,0.08)] overflow-hidden">
    <div className="flex items-stretch">
      <div className="min-w-0 flex-1">
        <div className="flex items-center justify-between gap-3 px-4 pt-4">
          <div className="text-xs font-medium text-[#5B84F6] tracking-[0.02em] uppercase">
            Điều chỉnh đang chờ duyệt
          </div>
        </div>
        <div className="grid grid-cols-3 gap-4 px-4 py-4 w-full text-sm">
          <div>
            <label className="block text-xs text-[#7C94D6] mb-2">
              Nội dung điều chỉnh <span className="text-red-500">*</span>
            </label>
            <CustomInput value={adjustment?.reason || ""} onChange={(val) => onUpdate("reason", val)} height="43px" required />
          </div>
          <div>
            <label className="block text-xs text-[#7C94D6] mb-2">Loại điều chỉnh</label>
            <CustomSelect value={NEW_ADJUSTMENT_TYPE_OPTIONS.find((opt) => opt.value === adjustment?.type)} options={NEW_ADJUSTMENT_TYPE_OPTIONS} onChange={(opt) => onUpdate("type", opt.value)} height="43px" required />
          </div>
          <div>
            <label className="block text-xs text-[#7C94D6] mb-2">Số tiền</label>
            <CustomInput type="number" value={adjustment?.amount || 0} onChange={(val) => onUpdate("amount", Number(val) || 0)} height="43px" />
          </div>
        </div>
      </div>
      <RemoveButton
        onClick={onRemove}
        title="Xoá điều chỉnh đang chờ duyệt"
      />
    </div>
  </div>
);

export const PendingAdjustmentCard = ({ adjustment, onUpdate, onRemove }) => (
  <div className="bg-[#F9FAFB] rounded-[16px] mb-3">
    <div className="flex items-stretch">
      <div className="grid grid-cols-3 gap-4 px-4 py-4 flex-1">
        <div>
          <label className="block text-xs text-gray-600 mb-2">
            Nội dung điều chỉnh <span className="text-red-500">*</span>
          </label>
          <CustomInput
            placeholder="Nhập nội dung"
            value={adjustment?.reason || ""}
            onChange={(val) => onUpdate("reason", val)}
            height="43px"
            required
          />
        </div>
        <div>
          <label className="block text-xs text-gray-600 mb-2">Loại điều chỉnh</label>
          <CustomSelect
            options={NEW_ADJUSTMENT_TYPE_OPTIONS}
            value={NEW_ADJUSTMENT_TYPE_OPTIONS.find((opt) => opt.value === adjustment?.type)}
            onChange={(opt) => onUpdate("type", opt.value)}
            placeholder="Chọn loại"
            height="43px"
            required
          />
        </div>
        <div>
          <label className="block text-xs text-gray-600 mb-2">Số tiền</label>
          <CustomInput
            type="number"
            placeholder="0"
            value={adjustment?.adjustmentAmount || 0}
            onChange={(val) => onUpdate("adjustmentAmount", Number(val) || 0)}
            height="43px"
          />
        </div>
      </div>
      <button
        onClick={onRemove}
        className="w-10 rounded-r-xl bg-[#FD5C5C] hover:bg-red-500 flex items-center justify-center transition-colors shadow-sm"
      >
        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
);
